<footer class="footer-container font-pt-sans">
  <span>&copy;&nbsp;Porozmawiaj.my&nbsp;{{ currentYear }}</span>
</footer>
